import Vue from 'vue'
import VueRouter from 'vue-router'
import { sync } from 'vuex-router-sync'
import routes from './routes'
import store from '@/store'
import cookie from '@/utils/cookie'
import { vueAppPassportDomin } from '@ca/constants/variables'

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!cookie.getCookie('Authnized')) {
      Vue.prototype.$toast({
        message: 'Please login first',
        type: 'error',
        duration: 2000
      })
      window.location = `${vueAppPassportDomin}/Login${to.meta.isLoginReturn ? '?return_url=' + encodeURIComponent(window.location.href) : ''}`
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router

const unsync = sync(store, router)
export { unsync }
